import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-bb1d35b4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "aui-flexView"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("header", {
  class: "aui-navBar aui-navBar-fixed"
}, null, -1));
const _hoisted_3 = {
  class: "aui-scrollView"
};
const _hoisted_4 = {
  class: "aui-mine-head"
};
const _hoisted_5 = {
  class: "aui-flex"
};
const _hoisted_6 = {
  class: "aui-flex-box"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "我的个人主页", -1));
const _hoisted_8 = {
  class: "aui-mine-user"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "aui-palace"
}, null, -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "divHeight"
}, null, -1));
const _hoisted_12 = {
  class: "aui-course-list"
};
const _hoisted_13 = {
  href: "javascript:;",
  class: "aui-flex b-line"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "aui-cou-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "/static/icon-fl-001.png",
  alt: ""
})], -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "aui-flex-box"
}, [/*#__PURE__*/_createElementVNode("h3", null, "会员时间")], -1));
const _hoisted_16 = {
  class: "aui-arrow"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "aui-cou-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "/static/icon-fl-001.png",
  alt: ""
})], -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "aui-flex-box"
}, [/*#__PURE__*/_createElementVNode("h3", null, "编辑资料")], -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "aui-arrow"
}, [/*#__PURE__*/_createElementVNode("span")], -1));
const _hoisted_20 = [_hoisted_17, _hoisted_18, _hoisted_19];
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "aui-cou-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "/static/icon-fl-001.png",
  alt: ""
})], -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "aui-flex-box"
}, [/*#__PURE__*/_createElementVNode("h3", null, "修改密码")], -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "aui-arrow"
}, [/*#__PURE__*/_createElementVNode("span")], -1));
const _hoisted_24 = [_hoisted_21, _hoisted_22, _hoisted_23];
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "aui-cou-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "/static/icon-fl-005.png",
  alt: ""
})], -1));
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "aui-flex-box"
}, [/*#__PURE__*/_createElementVNode("h3", null, "关于我们")], -1));
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "aui-arrow"
}, [/*#__PURE__*/_createElementVNode("span")], -1));
const _hoisted_28 = [_hoisted_25, _hoisted_26, _hoisted_27];
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "divHeight"
}, null, -1));
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "aui-text-body"
}, [/*#__PURE__*/_createElementVNode("p", null, "客服电话 xxx-xxx-xxxx 工作时间 9:30-18:30"), /*#__PURE__*/_createElementVNode("p", null, "浙ICP备2024096554"), /*#__PURE__*/_createElementVNode("p", null, "用户协议隐私政策 | 经营执照 | 防骗指南")], -1));
import { ref } from 'vue';
import { showNotify } from '@nutui/nutui';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import service from '@/utils/request';
import request from '@/utils/request';
export default {
  __name: 'MyView',
  setup(__props) {
    const timeNotify = msg => {
      showNotify.warn(msg, {
        duration: 2000
      });
    };
    const successNotify = msg => {
      showNotify.success(msg);
    };
    const store = useStore();
    const router = useRouter();
    const formData = ref({
      nickName: store.state.user.nickName,
      phonenumber: store.state.user.phonenumber,
      email: store.state.user.email,
      sex: store.state.user.sex
    });
    const formPwd = ref({
      oldPassword: "",
      newPassword: "",
      confirmPassword: ""
    });
    const formRef = ref(null);
    const formPwdRef = ref(null);
    const isVisible = ref(false);
    const isShow = ref(false);
    const user = ref(store.state.user);
    const fullTime = store.state.fullUser ? store.state.user.endDate : "未开通";
    //const user = ref({ nickName: "暂未登录", avatar: "" });
    const logout = async () => {
      const response = await service.post('/logout', {});
      if (response.code == 200) {
        localStorage.removeItem('token');
        store.dispatch('logout');
        // 根据需要重定向到首页或其他页面
        router.push('/login');
      } else {
        timeNotify(response.msg);
      }
      // 退出登录的逻辑，比如清除token、跳转到登录页等
      // 这里只是简单地打印一条消息
      console.log('用户已退出登录');
      // 你可能需要使用路由来导航到登录页面，例如：
      // router.push('/login');
    };
    // 失去焦点校验
    const customBlurValidate = prop => {
      formRef.value?.validate(prop).then(({
        valid,
        errors
      }) => {
        if (valid) {
          console.log('success:', formData.value);
        } else {
          console.warn('error:', errors);
        }
      });
    };
    const customPwdBlurValidate = prop => {
      formPwdRef.value?.validate(prop).then(({
        valid,
        errors
      }) => {
        if (valid) {
          console.log('success:', formPwd.value);
        } else {
          console.warn('error:', errors);
        }
      });
    };
    const toExplain = () => {
      router.push('/explain');
    };
    const toFullTime = () => {
      router.push('/fullTime');
    };
    const openInfo = () => {
      formData.value = {
        nickName: store.state.user.nickName,
        phonenumber: store.state.user.phonenumber,
        email: store.state.user.email,
        sex: store.state.user.sex
      };
      isVisible.value = true;
    };
    const openPwd = () => {
      formPwd.value = {
        oldPassword: "",
        newPassword: "",
        confirmPassword: ""
      };
      isShow.value = true;
    };
    const nameLengthValidator = val => {
      if (val == formPwd.value.newPassword) {
        return Promise.resolve();
      } else {
        return Promise.reject('两次输入的密码不一致');
      }
    };
    const submit = () => {
      formRef.value?.validate().then(({
        valid,
        errors
      }) => {
        if (valid) {
          updateUserProfile();
        } else {
          console.warn('error:', errors);
        }
      });
    };
    const submitPwd = () => {
      formPwdRef.value?.validate().then(({
        valid,
        errors
      }) => {
        if (valid) {
          updateUserPwd();
        } else {
          console.warn('error:', errors);
        }
      });
    };
    const updateUserProfile = async () => {
      // 发送登录请求
      const response = await service.put('/system/user/profile', {
        nickName: formData.value.nickName,
        phonenumber: formData.value.phonenumber,
        email: formData.value.email,
        sex: formData.value.sex
      });
      if (response.code == 200) {
        // 假设响应中包含一个token字段，我们将其保存到localStorage中
        successNotify("编辑成功");
        getInfo();
        isVisible.value = false;
      } else {
        timeNotify(response.msg);
      }
    };
    const updateUserPwd = async () => {
      // 发送登录请求
      const response = await service.put('/system/user/profile/updatePwd?oldPassword=' + formPwd.value.oldPassword + "&newPassword=" + formPwd.value.newPassword);
      if (response.code == 200) {
        // 假设响应中包含一个token字段，我们将其保存到localStorage中
        successNotify("修改成功");
        localStorage.setItem('password', formPwd.value.newPassword);
        isShow.value = false;
      } else {
        timeNotify(response.msg);
      }
    };
    const getInfo = () => {
      request.get('/getInfo').then(res => {
        if (res.code == 200) {
          // 登录成功，更新Vuex状态
          store.dispatch('login', res);
          user.value = res.user;
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_nut_avatar = _resolveComponent("nut-avatar");
      const _component_nut_button = _resolveComponent("nut-button");
      const _component_nut_input = _resolveComponent("nut-input");
      const _component_nut_form_item = _resolveComponent("nut-form-item");
      const _component_nut_radio = _resolveComponent("nut-radio");
      const _component_nut_radio_group = _resolveComponent("nut-radio-group");
      const _component_nut_space = _resolveComponent("nut-space");
      const _component_nut_form = _resolveComponent("nut-form");
      const _component_nut_popup = _resolveComponent("nut-popup");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("section", _hoisted_1, [_hoisted_2, _createElementVNode("section", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("h2", null, _toDisplayString(user.value.nickName), 1), _hoisted_7]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_nut_avatar, {
        size: "large"
      }, {
        default: _withCtx(() => [user.value.avatar != '' ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: user.value.avatar
        }, null, 8, _hoisted_9)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createTextVNode(_toDisplayString(user.value.nickName.charAt(0)), 1)], 64))]),
        _: 1
      })])]), _hoisted_10]), _hoisted_11, _createElementVNode("div", _hoisted_12, [_createElementVNode("a", _hoisted_13, [_hoisted_14, _hoisted_15, _createElementVNode("div", _hoisted_16, [_createElementVNode("span", null, _toDisplayString(_unref(fullTime)), 1)])]), _createElementVNode("a", {
        href: "javascript:;",
        class: "aui-flex b-line",
        onClick: openInfo
      }, _hoisted_20), _createElementVNode("a", {
        href: "javascript:;",
        class: "aui-flex b-line",
        onClick: openPwd
      }, _hoisted_24), _createElementVNode("a", {
        href: "javascript:;",
        class: "aui-flex b-line",
        onClick: toExplain
      }, _hoisted_28)]), _hoisted_29, _createVNode(_component_nut_button, {
        shape: "square",
        type: "default",
        block: "true",
        onClick: logout
      }, {
        default: _withCtx(() => [_createTextVNode("退出登录")]),
        _: 1
      }), _hoisted_30])]), _createVNode(_component_nut_popup, {
        visible: isVisible.value,
        "onUpdate:visible": _cache[5] || (_cache[5] = $event => isVisible.value = $event),
        closeable: "",
        style: {
          padding: '50px 10px',
          width: '90%',
          overflow: 'auto'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_nut_form, {
          ref_key: "formRef",
          ref: formRef,
          "model-value": formData.value,
          rules: {
            nickName: [{
              required: true,
              message: '用户昵称不能为空'
            }]
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_nut_form_item, {
            label: "用户昵称",
            prop: "nickName"
          }, {
            default: _withCtx(() => [_createVNode(_component_nut_input, {
              modelValue: formData.value.nickName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.value.nickName = $event),
              placeholder: "请输入用户昵称",
              type: "text",
              onBlur: _cache[1] || (_cache[1] = $event => customBlurValidate('nickName'))
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_nut_form_item, {
            label: "手机号码",
            prop: "phonenumber",
            rules: [{
              required: true,
              message: '手机号码不能为空'
            }, {
              regex: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
              message: '请输入正确的手机号码'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_nut_input, {
              modelValue: formData.value.phonenumber,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.value.phonenumber = $event),
              placeholder: "请输入手机号码",
              type: "text"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_nut_form_item, {
            label: "邮箱"
          }, {
            default: _withCtx(() => [_createVNode(_component_nut_input, {
              modelValue: formData.value.email,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formData.value.email = $event),
              placeholder: "请输入邮箱",
              type: "text"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_nut_form_item, {
            label: "性别"
          }, {
            default: _withCtx(() => [_createVNode(_component_nut_radio_group, {
              modelValue: formData.value.sex,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => formData.value.sex = $event),
              direction: "horizontal"
            }, {
              default: _withCtx(() => [_createVNode(_component_nut_radio, {
                label: "0"
              }, {
                default: _withCtx(() => [_createTextVNode("男")]),
                _: 1
              }), _createVNode(_component_nut_radio, {
                label: "1"
              }, {
                default: _withCtx(() => [_createTextVNode("女")]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_nut_space, {
            style: {
              "margin": "10px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_nut_button, {
              type: "primary",
              size: "small",
              onClick: submit
            }, {
              default: _withCtx(() => [_createTextVNode("提交")]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model-value"])]),
        _: 1
      }, 8, ["visible"]), _createVNode(_component_nut_popup, {
        visible: isShow.value,
        "onUpdate:visible": _cache[10] || (_cache[10] = $event => isShow.value = $event),
        "z-index": 10,
        closeable: "",
        style: {
          padding: '50px 10px',
          width: '90%',
          overflow: 'auto'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_nut_form, {
          ref_key: "formPwdRef",
          ref: formPwdRef,
          "model-value": formPwd.value,
          rules: {
            oldPassword: [{
              required: true,
              message: '旧密码不能为空'
            }]
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_nut_form_item, {
            label: "旧密码",
            prop: "oldPassword"
          }, {
            default: _withCtx(() => [_createVNode(_component_nut_input, {
              modelValue: formPwd.value.oldPassword,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => formPwd.value.oldPassword = $event),
              placeholder: "请输入旧密码",
              type: "password",
              onBlur: _cache[7] || (_cache[7] = $event => customPwdBlurValidate('oldPassword'))
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_nut_form_item, {
            label: "新密码",
            prop: "newPassword",
            rules: [{
              required: true,
              message: '新密码不能为空'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_nut_input, {
              modelValue: formPwd.value.newPassword,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => formPwd.value.newPassword = $event),
              placeholder: "请输入新密码",
              type: "password"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_nut_form_item, {
            label: "确认密码",
            prop: "confirmPassword",
            rules: [{
              required: true,
              message: '确认密码不能为空'
            }, {
              message: '两次输入的密码不一致',
              validator: nameLengthValidator
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_nut_input, {
              modelValue: formPwd.value.confirmPassword,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => formPwd.value.confirmPassword = $event),
              placeholder: "请输入确认密码",
              type: "password"
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["rules"]), _createVNode(_component_nut_space, {
            style: {
              "margin": "10px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_nut_button, {
              type: "primary",
              size: "small",
              onClick: submitPwd
            }, {
              default: _withCtx(() => [_createTextVNode("提交")]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model-value"])]),
        _: 1
      }, 8, ["visible"])], 64);
    };
  }
};